import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const PsihoterapieIndividuala = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Psihoterapia Individuală</h1>
          <p>
            Speram ca ai citit descrierile pe care ti le am oferit la sectiunea
            “Psihoterapie” (anterioara) despre ce inseamna acest proces si care
            ii este scopul.
          </p>
          <p>
            Cu siguranta ai inteles ca la baza procesului psihoterapeutic sta
            RELATIA buna si sustinatoare bazata pe incredere si siguranta, cu un
            psihoterapeut pregatit, relatie care va deveni incubatorul
            procesului de intelegere, crestere si dezvoltare.
          </p>
          <p>
            In spatiul AWARE oferim servicii de psihoterapie individuala care
            vizeaza sprijin si interventie pentru probleme si situatii diverse:
          </p>
          <ul>
            <li>
              Probleme legate de calitatea vietii, din diverse dimensiuni
              relationale: relatia cu partenerul, relatia cu copiii, cu jobul
              sau poate relatia cu tine insuti.
            </li>
            <li>
              Stari de anxietate: anxietate anticipativa, anxietate sociala, de
              performanta sau orice alta forma de frica, anxietate sau fobie, de
              la temeri si griji exagerate care iti fura din libertate pana la
              atacuri de panica.
            </li>
            <li>Tristete frecventa, impovarare, depresie</li>
            <li>
              - Suferinte si pierderi, travaliu de doliu: pierderea unei
              persoane dragi, divort, despartire, pierderea oportunitatilor,
              sindromul cuibului gol...
            </li>
            <li>
              Lipsa de incredere si constante sentimente de deficienta si
              valoare de sine precara care iti afecteaza viata si relatiile:
              stima de sine scazuta, dvalorizare, negativism, neajutorare,
              dependenta de celalalt, sine infantil.
            </li>
            <li>
              Manifestari psihosomatice: afectarea sanatatii si a starii fizice
              fara o explicatie medicala
            </li>
            <li>Confruntarea cu diverse tipuri de dependente</li>
          </ul>
          <p>
            Psihoterapeutul este cel/cea care te poate insoti in acest proces de
            autocunoastere.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PsihoterapieIndividuala;
